<template>
    <a href="javascript:void(0)" :class="current" :data-scp="scp" @click.stop="goSearch()">
        <i class="icon icon-search"></i><span></span>
    </a>
</template>

<script>
    export default {
        props: ['current', 'scp']
        , methods: {
            goSearch(){
                this.$dispatch('goSearch');
            }
        }
    };
</script>